import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
const DEFAULT_TITLE = 'Obchodní podmínky';
export default class TermsAndConditionsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.error = null;
    this.title = DEFAULT_TITLE;
    this.contentHtml = null;
    app.history.push('diaTheme.terms', DEFAULT_TITLE);
    app.setTitle(DEFAULT_TITLE);
    app.setTitleCount(0);
    this.bodyClass = 'App--terms';
    this.load();
  }
  load() {
    this.loading = true;
    this.error = null;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/dia-theme/terms-and-conditions'
    }).then(response => {
      const data = (response == null ? void 0 : response.data) || {};
      this.title = typeof data.title === 'string' && data.title.trim() !== '' ? data.title : DEFAULT_TITLE;
      this.contentHtml = typeof data.contentHtml === 'string' ? data.contentHtml : null;
      this.loading = false;
      app.setTitle(this.title);
      m.redraw();
    }).catch(() => {
      this.loading = false;
      this.error = 'Obchodní podmínky se nepodařilo načíst. Zkuste to prosím později.';
      m.redraw();
    });
  }
  view() {
    return m('.TermsPage', [m('.container', [m('article.TermsPage-article', [m('h1.TermsPage-title', this.title), this.loading ? m('.TermsPage-loading', m(LoadingIndicator)) : null, !this.loading && this.error ? m('p.TermsPage-error', this.error) : null, !this.loading && !this.error && this.contentHtml ? m('.TermsPage-content.Post-body', m.trust(this.contentHtml)) : null, !this.loading && !this.error && !this.contentHtml ? m('p.TermsPage-empty', 'Obsah obchodních podmínek není k dispozici.') : null])])]);
  }
}
flarum.reg.add('dia-theme', 'forum/features/terms/TermsAndConditionsPage', TermsAndConditionsPage);